export default {
      id: "search-icon-usage",
      viewBox: "0 0 22 21",
      url: __webpack_public_path__ + "sprite.svg#search-icon",
      toString: function () {
        return this.url;
      }
    }